import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentPlan',
})
export class PaymentPlanPipe implements PipeTransform {
  plan: string = '';
  transform(value: number): string {
    switch (value) {
      case 1:
        this.plan = 'One-off';
        break;
      case 2:
        this.plan = 'Daily';
        break;
      case 3:
        this.plan = 'Weekly';
        break;
      case 4:
        this.plan = 'Monthly';
        break;
    }
    return this.plan;
  }
}
